import React from 'react';
import styled from 'styled-components';
import SelectBox from '../../shared/component/SelectBox';
import { DimensionsType } from '../../shared/enum/EnumRepository';

const MIXED = 'MIXED' as const;
const OPTIONS = [
  DimensionsType.FIXED,
  DimensionsType.CUSTOM,
  DimensionsType.VARIABLE,
] as const;

const getLabel = (value: DimensionsType | typeof MIXED): string => {
  if (value === DimensionsType.FIXED) return 'Fixed';
  if (value === DimensionsType.CUSTOM) return 'Custom';
  if (value === DimensionsType.VARIABLE) return 'Variable';
  return 'Mixed';
};

interface DimensionsTypeSelectProps {
  value: DimensionsType | null;
  onChange: (value: DimensionsType) => void;
}

const DimensionsTypeSelect: React.FC<DimensionsTypeSelectProps> = ({
  value,
  onChange,
}) => {
  const selected =
    value === DimensionsType.FIXED
    || value === DimensionsType.CUSTOM
    || value === DimensionsType.VARIABLE
      ? value
      : MIXED;

  return (
    <SelectWrapper>
      <SelectBox<DimensionsType | typeof MIXED>
        value={selected}
        options={OPTIONS}
        handleChange={(next) => {
          if (next !== MIXED) onChange(next);
        }}
        direction={false}
        getDisplayText={getLabel}
      />
    </SelectWrapper>
  );
};

const SelectWrapper = styled.div`
  width: 92px;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

export default DimensionsTypeSelect;
